import DataTable from "react-data-table-component";
import Checkbox from "@material-ui/core/Checkbox";
import { makeStyles } from '@material-ui/core/styles';
import { Link, useHistory } from 'react-router-dom';
import React, { useState, useMemo, useCallback, useEffect, Fragment, useRef } from 'react';
import {Row, Col} from 'react-bootstrap';
import Button from '@material-ui/core/Button';
import { toast } from 'react-toastify';
import BrowseDatabaseServices from "../../services/browseDatabase";
import styled from "styled-components";
import { url } from '../../reducers/url';
import { useSelector } from "react-redux";
import CustomPagination from '../../shared/CustomPagination';
import Modal from 'react-bootstrap/Modal'
import CloseIcon from '@material-ui/icons/Close';
import FolderTreeMenu from '../../shared/FolderTreeStructure/FolderTreeMenu';
import ListGroup from 'react-bootstrap/ListGroup';
import TextInput from '../../shared/Fields/TextInput';
import Constant from '../../helpers/constant';
import utilsService, { TOAST_TYPE } from '../../helpers/utils';
import SearchManagementService from '../../services/searchmanagement'
import _, { } from "lodash";
//import * as XLSX from 'xlsx';
import XLSX from 'sheetjs-style';
import { saveAs } from 'file-saver';
import folderIcon from '../../assets/image/folder.png';
import sortdown from '../../assets/image/sort-down-19g.png';
import sortright from '../../assets/image/sort-right-19g.png';
import databaseIcon from '../../assets/image/database-16x16.png';
import folderClosedIcon from '../../assets/image/folder_closed-16x16.png';

const useStyles = makeStyles((theme) => ({
    textHeading: {
        fontWeight: "700 !important",
        color: "#5A6868",
        fontSize: 'larger'
        // marginBottom: "400px",

    },
    modalClassConEF: {
        position: 'absolute',
        width: '96%',
        // height: '55%',
        top: '30%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        transform: 'translate(-50%, -50%)'
    },
    modalClassConEFDark: {
        position: 'absolute',
        width: '96%',
        // height: '55%',
        top: '30%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        transform: 'translate(-50%, -50%)',
        // backgroundColor: '#292929',
    },
    colorConDSIEF: {
        backgroundColor: 'gainsboro',
        marginTop: '35px',
        padding: '28px',
        // paddingTop: '28px',
        paddingBottom: '65px',
        marginLeft: '15px',
        marginRight: '15px',
        paddingRight: '10px',
        borderRadius: '5px',
    },
    colorConDSIEFDark: {
        backgroundColor: '#56545473',
        marginTop: '35px',
        padding: '28px',
        // paddingTop: '28px',
        paddingBottom: '65px',
        marginLeft: '15px',
        marginRight: '15px',
        paddingRight: '10px',
        borderRadius: '5px',
    },
    loginSubmitCancel: {
        backgroundColor: '#0182C5',
        borderColor: '#1F4E79',
        border: '1px solid #1F4E79',
        color: 'white',
        margin: '4px',
        textTransform: 'capitalize',
        '&:hover': {
            backgroundColor: '#0182C5',
            boxShadow: 'none',
        },
    },
    columnPadding: {
        paddingTop: '20px',
        paddingLeft: '20px'
    },
    columnPaddings: {
        paddingTop: '5px',
        paddingLeft: '877px'
    },
    line: {
        borderBottom: '1px solid #E7E4E4',
        paddingBottom: '20px',
    },
    columnPad: {
        paddingTop: '45px',
        // backgroundColor:'#292929'
    },
    projectTitle: {
        margin: '0px 4px',
        position: 'relative',
        top: '2px',
        fontSize: '14px',
        padding: '0'
    },
    displayTitle: {
        margin: '0px 4px',
        position: 'relative',
        top: '2px',
        fontSize: '18px',
        padding: '0'
    },
    projectListItem: {
        display: 'grid',
        padding: '0.2rem 0.25rem !important',
        border: 'none !important',
    },
    projectListItemDark: {
        display: 'grid',
        padding: '0.2rem 0.25rem !important',
        border: 'none !important',
        backgroundColor: '#292929',
    },
    projTitleActive: {
        backgroundColor: '#008EC5',
        color: '#fff',
        padding: '3px',
        borderRadius: '3px'
    },
    txtwrp: {
        overflow: 'hidden',
        //whiteSpace: 'nowrap',
        display: 'block',
        textOverflow: 'ellipsis'
    },
    folderIcon: {
        width: '8%'
    },
    modalHeader: {
        borderBottom: 'none !important',
    },
    modalBody: {
        paddingBottom: '20px'
    },
    modal_body: {
        padding: '10px 0 0 0'
    },
    modal_bodyDark: {
        padding: '10px 0 0 0',
        backgroundColor: '#292929'
    },
    footerDiv: {
        padding: '0 10px'
    },
    checkBox: {
        transform: "scale(0.9)",
    },
    addNewLabel: {
        marginTop: '-20px',
        marginLeft: '31px'
    },
    addNewText: {
        marginTop: '-6px',
        marginLeft: '30px',
        height: '65px'
    },
    modalBoxContent: {
        maxHeight: '675px',
    },
    modalClassConDSI: {
        // backgroundColor: '#302d2d',
        width: '96%',
        padding: '35px 15px 15px',
        // height: 'auto',
        // top: '30%',
        // left: '50%',
        right: 'auto',
        bottom: 'auto',
        // transform: 'translate(-50%, -50%)'
    },
    modalClassConDSIDark: {
        backgroundColor: '#302d2d',
        width: '96%',
        padding: '35px 15px 15px',
        // height: 'auto',
        // top: '30%',
        // left: '50%',
        right: 'auto',
        bottom: 'auto',
        // transform: 'translate(-50%, -50%)'
    },
    modalWide: {
        position: 'absolute',
        width: '120%',
        padding: '35px 15px 15px',
        right: 'auto',
        bottom: 'auto',
    },

    modalClassConDR: {
        position: 'absolute',
        width: '96%',
        height: '46%',
        top: '30%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        transform: 'translate(-50%, -50%)'
    },
    modaltext: {
        position: 'absolute',
        top: '10px',
        right: '10px'
    },

    colorConDSI: {
        backgroundColor: 'gainsboro',
        // marginTop: '-38px',
        padding: '28px',
        paddingTop: '28px',
        paddingBottom: '65px',
        // marginLeft: '7px',
        // marginRight: '7px',
        paddingRight: '10px',
        borderRadius: '5px',
    },
    colorConDSIDark: {
        backgroundColor: '#545454f5',
        // marginTop: '-38px',
        padding: '28px',
        paddingTop: '28px',
        paddingBottom: '65px',
        // marginLeft: '7px',
        // marginRight: '7px',
        paddingRight: '10px',
        borderRadius: '5px',
    },
    footerDivDSI: {
        marginTop: '-26px',
        marginRight: ' -30px',
    },
    modalHeaderConMTF: {
        borderBottom: 'none !important',
        position: 'absolute',
        right: '0px',
        top: '0px',
        zIndex: '1'
    },

    modalClassConMTF: {
        position: 'relative',
        width: '96%',
        height: 'auto',
    },
    colorConMTF: {
        backgroundColor: 'gainsboro',
        padding: '15px 10px 50px 15px',
        margin: '30px 15px 15px',
        borderRadius: '5px',
    },
    colorConMTFDark: {
        backgroundColor: '#56545473',
        padding: '15px 10px 50px 15px',
        margin: '30px 15px 15px',
        borderRadius: '5px',
    },
    footerDivMTF: {
        marginTop: '-8px',
    },
    modalClassContent: {
        position: 'absolute',
        width: '96%',
        height: 'auto',
        top: '30%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        transform: 'translate(-50%, -50%)'
    },
    colorContainer: {
        backgroundColor: 'gainsboro',
        marginTop: '-38px',
        // marginLeft: 0px;
        paddingTop: '28px',
        paddingBottom: '65px',
        marginLeft: '7px',
        marginRight: '7px',
        paddingRight: '10px',
        borderRadius: '5px',
    },
    popupFolderIcon: {
        width: '3% !important'
    },
    sharedFolderText: {
        fontSize: '14px',
    },
    selectedTitle: {
        backgroundColor: '#337ab7',
        color: '#fff',
        padding: '3px',
        borderRadius: '3px'
    },
    buttonStyle: {
        backgroundColor: '#EEEEEE !important',
        border: '1px solid #CCCCCC !important',
        float: 'right',
        textTransform: 'none !important',
        marginTop: '4px !important',
        color: '#777777!important',
        boxShadow: 'none !important'
    },
    loader: {
        position: 'fixed',
        top: '0',
        left: '0',
        width: '100%',
        height: '100%',
        zIndex: '999999',
        backgroundColor: 'rgba(0, 0, 0, 0.6)',
        display: 'block',
    },
    disabledButtonStyle: {
        float: 'right',
        textTransform: 'none !important',
        marginTop: '4px !important',
        backgroundColor: '#db862c!important',
        border: '1px solid #ca751b!important',
        color: 'white !important'
    },
    isInvalid: {
        border: '1px solid red !important',
    },
    tableResizable: {
    '& .rdt_TableHeadRow': {
        '& .rdt_TableCol': {
            position: 'relative',
            userSelect: 'none',
            '&:not(:last-child)::after': {
                content: '""',
                position: 'absolute',
                top: 0,
                right: 0,
                width: '8px',
                height: '100%',
                cursor: 'col-resize',
                backgroundColor: 'transparent',
                zIndex: 10,
                '&:hover': {
                    backgroundColor: 'rgba(235, 238, 242, 0.2)',
                },
            },
            '&.resizing': {
                userSelect: 'none',
                '&::after': {
                    backgroundColor: '#c4c7caff',
                },
            },
        },
    },
},
}));

const customStyles = {
    headRow: {
        style: {
            backgroundColor: '#white', // Set to transparent or remove this property
        },
    },
    rows: {
        style: {
            minHeight: '50px', // override the row height
        }
    },
    headCells: {
        style: {
            paddingLeft: '8px', // override the cell padding for head cells
            paddingRight: '8px',
            // borderLeft:'1px solid #0606061f',
            borderRight: '1px solid #0606061f',
            '&:first-child': {
                borderLeft: '0',
                borderRight: '0'
            },
            '&:last-child': {
                borderRight: '0',
                paddingLeft: '20px',
            },
            fontWeight: 'bold',
            color: '#4a5050',
        },
    },
    cells: {
        style: {
            paddingLeft: '8px', // override the cell padding for data cells
            paddingRight: '8px',
            // borderLeft:'1px solid #0606061f',
            borderRight: '1px solid #0606061f',
            borderBottom: '1px solid #0606061f',
            '&:first-child': {
                borderLeft: '0',
                borderRight: '0'
            },
            '&:last-child': {
                borderRight: '0',
                paddingLeft: '20px',
            },
            '&:second-child': {
                borderLeft: '0',
            },

            display: 'grid'
        },

    },
};

const customStylesDark = {
    headRow: {
        style: {
            backgroundColor: '#292929',
        },
    },
    rows: {
        style: {
            minHeight: '50px',
            backgroundColor: '#292929',
            color: 'white',
        },
    },
    headCells: {
        style: {
            paddingLeft: '8px',
            paddingRight: '8px',
            borderBottom: '1px solid #777',
            borderRight: '1px solid #777',
            fontSize: '14px',
            fontWeight: 'bold',
            color: '#fff',
            backgroundColor: '#292929',
            textAlign: 'left',
        },
    },
    cells: {
        style: {
            paddingLeft: '8px',
            paddingRight: '8px',
            borderBottom: '1px solid #777',
            borderRight: '1px solid #777',
            color: 'white',
            backgroundColor: '#292929',
            textAlign: 'left',
        },
    },
    tableWrapper: {
        style: {
            backgroundColor: '#292929',
            borderRight: '0',
            marginRight: '0',
            paddingRight: '0',
            overflow: 'hidden',
        },
    },
    noData: {
        style: {
            backgroundColor: '#292929',
            color: 'white',
            height: '100%',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
        },
    },
};

const conditionalRowStyles = [
    {
        when: row => row.director < 300,
        style: {
            backgroundColor: 'green',
            color: 'white',
            '&:hover': {
                cursor: 'pointer',
            },
        },
    },
    // You can also pass a callback to style for additional customization
    {
        when: row => row.director < 300,
        style: row => ({
            backgroundColor: row.isSpecia ? 'pink' : 'inerit',
        }),
    },
];

const columns = [
     {
        name: "Name",
        cell: (row) => (
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                {(row.class === 'DlPhysicalSeqdb' || row.class === 'DlVirtualSeqdb') && (
                    <img src={databaseIcon} alt="database" style={{ width: '16px', height: '16px', flexShrink: 0 }} />
                )}
                {row.class === 'DlFolder' && (
                    <img src={folderClosedIcon} alt="folder" style={{ width: '16px', height: '16px', flexShrink: 0 }} />
                )}
                <span>{row.text_label}</span>
            </div>
        ),
        selector: "text_label",
        left: true,
        sortable: true,
        // width: '50%',
        minWidth: '250px',
        wrap: true,
    },
    // {
    //     name: "Type",
    //     selector: "class_name",
    //     // sortable: true,
    //     width: '10%',
    //     minWidth: '100px',
    // },
    // {
    //     name: "Actions",
    //     cell: (row) => row.actionContent,
    //     ignoreRowClick: true,
    //     allowOverflow: true,
    //     button: true,
    //     left: true,
    //     width: '15%',
    //     minWidth: '120px',
    // },
    {
        name: "Additional Info",
        cell: (row) => `nb of sequences: ${row.nb_sequences ?? 'N/A'}`,
        // sortable: true,
        left: true,
        width: '25%',
        minWidth: '150px',
    },
    {
        name: "Updated Time",
        selector: "update_time",
        sortable: true,
        left: true,
        width: '25%',
        minWidth: '150px',
    },

];


const isIndeterminate = indeterminate => indeterminate;
const selectableRowsComponentProps = { indeterminate: isIndeterminate };
var lookup = {}
let allResultSet = []; // store all records globally or in a higher scope
let lastFetchedFolderId = null; // Track last fetched folder outside the component

function BrowseDatabases() {
    const classes = useStyles();
    const [thing, setThing] = useState([]);
    const [checkValue, setCheckValue] = React.useState(false);
    const [checkMerge, setCheckMerge] = React.useState(false);
    const toggle = useSelector(state => state.setToggle.toggle);
    const [currentSortColumn, setCurrentSortColumn] = useState(null);
    //Pagination
    const pageCount = 50;
    const [currentPage, setCurrentPage] = useState(1);
    const history = useHistory();
    const [totalCount, setTotalCount] = useState();
    const [searchPersonalData, setSearchFormsData] = useState([]);
    const [modalShow, setModalShow] = React.useState(false);
    const [modalShowDatabases, setModalShowDatabases] = React.useState(false);
    const [currentSortParam, setCurrentSortParam] = useState("-create_time"); // default sort
    const [isSearchDone, setIsSearchDone] = useState(false);
    const [sortField, setSortField] = useState(null);
    const [searchSortField, setSearchSortField] = useState(null);
    const [idValue, setIdValues] = useState([]);
    const [moveFolderModalShow, setMoveFolderModalShow] = React.useState(false);
    const [moveFolderId, setMoveFolderId] = useState('');
    const [confirmFolderContent, setConfirmFolderContent] = useState(true);
    const [moveSelection, setMoveSelection] = useState();
    const [moveInfoFolderIds, setMoveInfoFolderIds] = useState([]);
    const [folderIds, setFolderIds] = useState([]);
    const [clearCheckedRow, setClearCheckedRow] = useState(false);
    const [expandedFolderIds, setExpandedFolderIds] = useState([]);
    const [isShared, setIsShared] = useState(false);
    const [infoFolderIds, setInfoFolderIds] = useState([]);
    const [defaultTitle, setDefaultTitle] = useState('Reference Databases');
    const [defaultTitleId, setDefaultTitleId] = useState('');
    const [folderDetail, setFolderDetail] = useState([]);
    const [parentFolderId, setParentFolderId] = useState('');
    const [showNewFolder, setShowNewFolder] = useState(false);
    const [showNewFolderModal, setShowNewFolderModal] = useState(false);
    const [addFolderText, setAddFolderText] = useState(true);
    const [emptyNameError, setEmptyNameError] = useState(false);
    const folderNameRef = useRef('');
    const [newFolderName, setNewFolderName] = useState();
    const [selectData, setSelectData] = useState();
    const [toggleCleared, setToggleCleared] = useState(false);
    const [addFolderModalShow, setAddFolderModalShow] = useState(false);
    const [rootFolderId, setRootFolderId] = useState([]);
    const [showMergeModal, setShowMergeModal] = useState(false);
    const [name, setName] = useState('');
    const [description, setDescription] = useState('');
    const RenameFolderNameRef = useRef('');
    const userInfo = useSelector((state) => state.setUserInfo);
    
    // //  Check if user is admin
    // const isAdmin = useMemo(() => {
    //     const result = userInfo && userInfo.current_user && userInfo.current_user.user_class_name === "adminium";
    //     console.log(' Admin Check:', {
    //         hasUserInfo: !!userInfo,
    //         hasCurrentUser: !!(userInfo && userInfo.current_user),
    //         userClassName: userInfo?.current_user?.user_class_name,
    //         isAdmin: result
    //     });
    //     return result;
    // }, [userInfo]);
    
    const [disableDelete, setDisableDelete] = useState(true);
    const [exportModal, setExportModal] = useState(false); // controls modal visibility
    const [exportHtmlModal, setExportHtmlModal] = useState(false);
    const [completeResultSet, setCompleteResultSet] = useState([]);
    const [searchResSet, setSearchResSet] = useState('');
    const [parentTreeObj, setParentTreeObj] = useState([]);
    const [checkFolder, setCheckFolder] = useState(false);
    const [moveFolderId1, setMoveFolderId1] = useState('');
    const [referenceChildren, setReferenceChildren] = useState([]);
    const [modalChildren, setModalChildren] = useState([]); 
    const [expanded, setExpanded] = useState(false);
    const [expandedChild, setExpandedChild] = useState(false);
    const [allFolders, setAllFolders] = useState([]);
    const [allFolderTextLabel, setAllFolderTextLabel] = useState([]);
    const [currentFolderId, setCurrentFolderId] = useState(4);
    const [termsDisable, setTermsDisable] = React.useState(false);
    const [confirmContent, setConfirmContent] = useState(true);
    const [delLoaderContent, setDelLoaderContent] = useState(false);
    const [errorContent, setErrorContent] = useState(false);
        // Modal states (separate from left panel)
    const [modalFolderTree, setModalFolderTree] = useState([]);
    const [modalSelectedFolder, setModalSelectedFolder] = useState(null);
    const [modalExpandedIds, setModalExpandedIds] = useState([]);
    const [rootFolderTree, setRootFolderTree] = useState([]);
    const [modalInfoFolderIds, setModalInfoFolderIds] = useState([]);
    // unlike class methods updateState will be re-created on each render pass, therefore, make sure that callbacks passed to onSelectedRowsChange are memoized using useCallback
    const updateThing = useCallback(state => setThing(state));
    const handleAction = value => setSelectData(value);
    const updateState = useCallback(state => setSelectData(state));
    const [childExpanded, setChildExpanded] = useState({}); // state for each child
//  LEFT PANEL - Completely separate state
const [leftPanelExpanded, setLeftPanelExpanded] = useState(true);
const [leftPanelChildren, setLeftPanelChildren] = useState([]);
const [leftPanelSelectedFolder, setLeftPanelSelectedFolder] = useState(null);
const [allReferenceDLFolders, setAllReferenceDLFolders] = useState([]);
const [showLoader, setShowLoader] = useState(false);


//  MODAL - Completely separate state  
const [modalExpanded, setModalExpanded] = useState(false); //  Not needed with FolderTreeMenu
// const [modalChildren, setModalChildren] = useState([]);
// const [modalSelectedFolder, setModalSelectedFolder] = useState(null);

//  Remove these shared variables:
// const [expanded, setExpanded] = useState(false);           // Remove
// const [expandedChild, setExpandedChild] = useState(false); // Remove
// const [moveFolderId1, setMoveFolderId1] = useState('');    // Remove
// const [referenceChildren, setReferenceChildren] = useState([]); // Remove

    const selectedRows = useMemo(
        () => (thing && Array.isArray(thing.selectedRows) ? thing.selectedRows : []),
        [thing]
    );
    const selectedCount = thing?.selectedCount || 0;
    const hasFolderSelected = useMemo(
        () => selectedRows.some(row => row?.class === 'DlFolder'),
        [selectedRows]
    );
    const canMergeDatabases = selectedCount >= 2 && !hasFolderSelected;

    function updateVal(state) {
        setThing(state);
        setSelectData(state);

        if (state.selectedCount >= 2) {
            setCheckValue(true);
            setCheckMerge(true);
        } else if (state.selectedCount === 1) {
            setCheckValue(true);
            setCheckMerge(false);
        } else {
            setCheckValue(false);
            setCheckMerge(false);
        }
    }

    function chechBoxFunction() {
        const TableContainer = styled.div`
      table {
          margin-left: 70px;
          margin-top: 37px;
          width:80%;
        tr {
          border-bottom: 2px solid #dee2e6;
          :first-child {
            border-top: 2px solid #dee2e6;
          }
        }
        td {
          color: 'black';
          :first-child {
            border-right: 2px solid #dee2e6;
            width: 180px;
          }
          :last-child {
            padding-left: 20px;

          }
        }
      }
    `;
    }
    // useEffect(() => {
    //     (async () => {
    //         getBrowseDataBase();
    //     })()
    // }, []);
    const escFunction = useCallback((event) => {
        if (event.keyCode === 27) {
            //Do whatever when esc is pressed
            setShowNewFolder(false);
            //setAddFolderText(true);
        }
    }, []);

    const PAGE_SIZE = 50;
    
    //  Fetch DLFolders from Reference Databases root on component mount
    useEffect(() => {
        fetchAllReferenceDlFolders();
    }, []); // Empty dependency - run once on mount

    useEffect(() => {
        const start = ((currentPage - 1) * PAGE_SIZE) + 1;
        const stop = start + PAGE_SIZE - 1;

        getBrowseDataBase(currentSortColumn, start, stop);
        document.addEventListener("keydown", escFunction, false);
        document.title = 'GenomeQuest - Browse Databases';

        // Add resizable columns functionality after a small delay
        const timer = setTimeout(() => {
            initializeColumnResizing();
        }, 100);
        
        return () => {
            document.removeEventListener("keydown", escFunction, false);
            clearTimeout(timer);
            cleanupColumnResizing();
        };
    }, [currentSortColumn, currentPage, currentFolderId]);


    
    // Add these functions for column resizing
    const initializeColumnResizing = () => {
        const table = document.querySelector('.search-table');
        if (!table) return;
    
        const headers = table.querySelectorAll('.rdt_TableCol');
        
        headers.forEach((header, index) => {
            if (index === headers.length - 1) return; // Skip last column
            
            // Remove existing resizer if any
            const existingResizer = header.querySelector('.column-resizer');
            if (existingResizer) {
                existingResizer.remove();
            }
            
            const resizer = document.createElement('div');
            resizer.className = 'column-resizer';
            resizer.style.cssText = `
                position: absolute;
                top: 0;
                right: 0;
                width: 8px;
                height: 100%;
                cursor: col-resize;
                background: transparent;
                z-index: 15;
            `;
            
            header.style.position = 'relative';
            header.appendChild(resizer);
            
            let isResizing = false;
            let startX = 0;
            let startWidth = 0;
            
            const handleMouseDown = (e) => {
                isResizing = true;
                startX = e.clientX;
                startWidth = header.offsetWidth;
                
                header.classList.add('resizing');
                document.body.style.cursor = 'col-resize';
                document.body.style.userSelect = 'none';
                
                e.preventDefault();
                e.stopPropagation();
            };
            
            const handleMouseMove = (e) => {
                if (!isResizing) return;
                
                const diff = e.clientX - startX;
                const newWidth = Math.max(80, startWidth + diff); // Minimum 80px
                
                header.style.width = newWidth + 'px';
                header.style.minWidth = newWidth + 'px';
                header.style.maxWidth = newWidth + 'px';
                header.style.flex = 'none';
                
                // Update corresponding data cells
                const columnIndex = Array.from(header.parentNode.children).indexOf(header);
                const rows = table.querySelectorAll('.rdt_TableRow');
                rows.forEach(row => {
                    const cell = row.children[columnIndex];
                    if (cell) {
                        cell.style.width = newWidth + 'px';
                        cell.style.minWidth = newWidth + 'px';
                        cell.style.maxWidth = newWidth + 'px';
                        cell.style.flex = 'none';
                    }
                });
            };
            
            const handleMouseUp = () => {
                if (!isResizing) return;
                
                isResizing = false;
                header.classList.remove('resizing');
                document.body.style.cursor = '';
                document.body.style.userSelect = '';
            };
            
            resizer.addEventListener('mousedown', handleMouseDown);
            document.addEventListener('mousemove', handleMouseMove);
            document.addEventListener('mouseup', handleMouseUp);
            
            // Store cleanup function
            header._cleanupResize = () => {
                resizer.removeEventListener('mousedown', handleMouseDown);
                document.removeEventListener('mousemove', handleMouseMove);
                document.removeEventListener('mouseup', handleMouseUp);
                if (resizer.parentNode) {
                    resizer.parentNode.removeChild(resizer);
                }
            };
        });
    };
    
    const cleanupColumnResizing = () => {
        const headers = document.querySelectorAll('.search-table .rdt_TableCol');
        headers.forEach(header => {
            if (header._cleanupResize) {
                header._cleanupResize();
            }
        });
    };
    
    const toggleChildExpand = (childId) => {
    setChildExpanded((prev) => ({
        ...prev,
        [childId]: !prev[childId], // toggle only this child
    }));
    };

    //  Function to fetch all DLFolders from Reference Databases root
    async function fetchAllReferenceDlFolders() {
        try {
            const nocache = Math.floor(Math.random() * 9999);
            const result = await BrowseDatabaseServices.getBrowseData(
                4, // Always fetch from Reference Databases root (id=4)
                "-create_time",
                nocache,
                1,
                100 // Get enough items to capture all folders
            );

            if (result && result.response_content && result.response_content.results) {
                const folders = result.response_content.results.filter(item => item.class === 'DlFolder');
                console.log('Fetched DLFolders from root:', folders);
                setAllReferenceDLFolders(folders);
                
                //  Also populate left panel children immediately
                setLeftPanelChildren(folders);
            }
        } catch (err) {
            console.error("Error fetching reference DlFolders:", err);
        }
    }

    async function getBrowseDataBase(sortParamFromUI, start = 1, stop = 50, isHtmlExport = false) {
        const id = currentFolderId;
        console.log('id in getBrowseDataBase', id);

        const nocache = Math.floor(Math.random() * 9999);
        const sortParam = sortParamFromUI || currentSortParam || "-create_time";

        let totalCount = 0;

        //  Fetch only the current page - NOT all records
        const result = await BrowseDatabaseServices.getBrowseData(
            id,
            sortParam,
            nocache,
            start,
            stop
        );

        if (result && result.response_content) {
            const pageData = result.response_content.results || [];
            totalCount = result.response_content.totalcount || pageData.length;

            const folders = pageData.filter(item => item.class === 'DlFolder');
            setAllFolders(folders);
            const textLabels = folders.map(folder => ({
                id: folder.id,
                text_label: folder.text_label
            }));
            setAllFolderTextLabel(textLabels);
            console.log('allFolderTextLabel', textLabels);

            const filteredList = pageData.filter(
                (p) => p.class === "DlPhysicalSeqdb" || p.class === "DlFolder" || p.class === "DlVirtualSeqdb"
            );

            await constrainTemplateData(filteredList);

            setSearchFormsData(filteredList);
            setTotalCount(totalCount);
        }

        setShowLoader(false);
    }

    // Add this handler inside your BrowseDatabases component:
    const handleFolderLinkClick = (e, folderId) => {
        e.preventDefault();

        setCurrentFolderId(folderId);
        setCurrentPage(1);
    };

    async function exportHTMLNow() {
        const id = currentFolderId;
        const nocache = Math.floor(Math.random() * 9999);
        const sortParam = currentSortColumn || "-create_time";

        try {
            // Get total count so we export everything
            const meta = await BrowseDatabaseServices.getBrowseData(id, sortParam, nocache, 1, 1);
            const totalCount = meta?.response_content?.totalcount ?? 0;

            const s1 = 1;
            const s2 = totalCount > 0 ? totalCount : 50; // fallback to 50 if count unknown

            const htmlUrl = (process.env.REACT_APP_API_URL + url.exportHTML)
                .replace(':id:', id)
                .replace(':ST:', encodeURIComponent(sortParam))
                .replace(':NC:', encodeURIComponent(nocache))
                .replace(':S1:', s1)
                .replace(':S2:', s2);

            window.open(htmlUrl, "_blank");
            setCurrentPage(1);
        } catch (err) {
        }
    }

    async function constrainTemplateData(resultCon) {

        resultCon.map(datas => {
            // Store the original string for sorting

            if (datas.class === 'DlPhysicalSeqdb') {
                let typeUrl = process.env.REACT_APP_API_URL + url.browseSeqDB.replace('**', datas.id);
                datas.typeContent = 'Physical Sequence Database';
                datas.text_label_raw = datas.text_label;
                datas.text_label = <Fragment>
                    <a href={typeUrl} target="_blank" rel="noreferrer">{datas.text_label}</a>

                </Fragment>
                // datas.actionContent = <Fragment>
                //     <a href={typeUrl} target="_blank" rel="noreferrer">Browse</a>
                // </Fragment>
            }
            else if(datas.class === 'DlVirtualSeqdb'){
                let typeUrl = process.env.REACT_APP_API_URL + url.browseSeqDB.replace('**', datas.id);
                datas.typeContent = 'Virtual Sequence Database';
                datas.text_label_raw = datas.text_label;
                datas.text_label = <Fragment>
                    <a href={typeUrl} target="_blank" rel="noreferrer">{datas.text_label}</a>

                </Fragment>
                // datas.actionContent = <Fragment>
                //     <a href={typeUrl} target="_blank" rel="noreferrer">Browse</a>
                // </Fragment>
            }
            else if (datas.class === 'DlFolder') {
                datas.typeContent = 'Virtual Sequence Database';
                datas.text_label_raw = datas.text_label;
                datas.text_label = (
                    <Fragment>
                        <a
                            href="#"
                            onClick={(e) => {
                                handleFolderLinkClick(e, datas.id);
                                //Highlight folder in left panel when clicked in DataTable
                                setLeftPanelSelectedFolder(datas.id);
                            }}

                        >
                            {datas.text_label}
                        </a>
                    </Fragment>
                );
            }
            else {
                datas.typeContent = datas.type;
                datas.nameContent = <Fragment>
                    <Link >{datas.description}</Link>
                </Fragment>
            }
        });
    }

    //browseDatabase : "do=gqfolder.get_elements&id=:id:&sort=:ST:&nocache=:NC:&start=:S1:&stop=:S2:&format=json",

    async function BrowseDatabase() {
        const selectedIds = selectData.selectedRows.map(row => row.id); // Extract IDs from selectedRows array
        const joinedIds = selectedIds.join(','); // Create comma-separated string: "3292,267,316"
        // const encodedId = encodeURIComponent(`id:${joinedIds}`);
        const finalUrl = process.env.REACT_APP_API_URL + url.browseSeqDB.replace('**', joinedIds);

        window.open(finalUrl, '_blank');
        setSelectData({});

        handleClearSelection();
    }

    const handleClearSelection = () => {
        setToggleCleared(prev => !prev); // Clears selected rows
        setSelectData({});
    };

    const changePage = async (e, page) => {
        if (page) {
            // const start = ((page - 1) * pageCount) + 1;
            // const stop = page * pageCount;
            const start = ((page - 1) * pageCount) + 1;
            const stop = Math.min(page * pageCount, totalCount);
            setCurrentPage(page);

            // Reuse the existing function with pagination values
            await getBrowseDataBase(currentSortColumn, start, stop, false);
        }
    };
    const handleFolderClick = e => {
        setIsShared(false)
        changeTitle(e)
    }
    const changeTitle = (event) => {
        //clear check box
        setClearCheckedRow(!clearCheckedRow);

        setDefaultTitle(event.text_label);
        RenameFolderNameRef.current = event.text_label;
        // setRenameFolder(false);
        setDefaultTitleId(event.id);
        setParentFolderId(event.id);
        // Finding Parent Object to display in Popup While Delete
        findParentObj(event);
        if (event.level == 3) {
            setAddFolderText(false);
            setShowNewFolder(false);
        } else {
            setAddFolderText(true);
        }
        // setTimeout(() => {
        if (event.text_label != "Recent Search Results") {
            setInfoFolderIds([]);
        }

        // Set those flags before calling the backend service
        setIsSearchDone(false);
        // setSearchResSet('');
        setCurrentPage(1);

        if (event.text_label == "Reference Databases") {
            //updateDefaultValue('My Searches');
            // setDisableFolderDelete(true);
        }
        // let start = 1;
        // let stop = pageCount;
        getDefaultSearchResult('folder', event.id, null);
        // } else {
        //     getDefaultSearchResult('folder', event.id);
        // }
        // getDefaultSearchResult('folder', event.id);
        if (!_.includes(infoFolderIds, parentFolderId)) {
            infoFolderIds.push(parentFolderId)
        }
        infoFolderIds.push(event.id)
        setInfoFolderIds(infoFolderIds);
        // }, 1000);
    };
    async function findParentObj(obj) {
        let parentObj = await findAncestors(obj.id);
        parentObj.push(obj.id);
        setParentTreeObj(...[parentObj]);
    }
    async function findAncestors(nodeId) {
        var ancestors = [];
        // ancestors.unshift(nodeId);
        var parentId = lookup[nodeId] && lookup[nodeId].parent_gq_folder_id;
        var desc = lookup[parentId] && lookup[parentId].description;
        var regex = new RegExp('home folder for', "i");
        var checkRootFolder = regex.test(desc);
        while (parentId !== undefined && parentId != '2') {
            ancestors.unshift(parentId)
            parentId = lookup[parentId] && lookup[parentId].parent_gq_folder_id;
        }
        return ancestors;
    }

    function mapIt(node) {
        lookup[node.id] = node;
        //recursive on all the children
        node.children && node.children.forEach(mapIt);
    }

    const sortTable = (column, sortDirection) => {
        let sortParam = "";

        if (column && column.name === "Name") {
            sortParam = (sortDirection === "asc" ? "+text_label" : "-text_label") + ",-create_time";
        } else if (column && column.name === "Updated Time") {
            sortParam = (sortDirection === "asc" ? "+update_time" : "-update_time") + ",-create_time";
        } else {
            sortParam = (sortDirection === "asc" ? "+text_label" : "-text_label") + ",-create_time";
        }

        setCurrentSortParam(sortParam);

        // force reload allResultSet with new sort
        getBrowseDataBase(sortParam, 1, PAGE_SIZE, false);
    };

    const addNewFolder = (e) => {
        e.preventDefault();
        setShowNewFolderModal(true);
        setShowMergeModal(true);
        //setShowNewFolder(true);
        //setAddFolderText(!addFolderText);
        //document.getElementById("addNewFolder").focus();
    }
    async function deleteTemplate() {
        const data = [];
        const dataValues = thing && thing.selectedRows && data.push(thing.selectedRows[0]);
        if (thing && thing.selectedCount >= 1 && data && data.length > 0) {
            // setSelectedTemplateData();
            setModalShow(true);
        }
        else {
            toast.error("Select Any One Item");

        }

    }
    async function deleteForm() {

        const data = [];
        const dataValues = thing && thing.selectedRows && data.push(thing.selectedRows[0]);

        if (thing && thing.selectedCount >= 1 && data && data.length > 0) {

            const personaldata = thing.selectedRows;
            const personalId = [];
            await personaldata && personaldata.length > 0 && personaldata.forEach(res => {
                personalId.push(res.id)
            });

            const result = await BrowseDatabaseServices.deletePerData(personalId, thing.selectedCount);
            // getPersonalData();
            setModalShow(false);
            setCheckValue(false);
            setThing({});
            setDisableDelete(true);
            handleClearSelection();
            toast.success("The database is deleted successfully");
        }
        else {
            toast.error("Select Any One Item");

        }
        await getBrowseDataBase(currentSortColumn, 1, PAGE_SIZE, false);
        setCurrentPage(1);
        // setModalShow(true);
    }
    function cancelForms() {
        setModalShow(false);
    }
    const getFolderName = async (e) => {
        if (e.keyCode == 13) {
            addFolderName(e.target.value);
        }
    }

    async function addFolderName(name) {
        if (!name || "" == name) {
            setEmptyNameError(true);
            //setAddFolderModalShow(true);
            return;
        }
        setShowNewFolderModal(false);
        // const folderData = await SearchManagementService.getProjectFolders(history);
        // setParentFolderId(folderData.response_content.id);
        let restrictedNamesArray = Constant.folderRestrictNames
        let isRestrictedName = false;
        for (let i = 0; i < restrictedNamesArray.length; i++) {
            if (restrictedNamesArray[i].toLowerCase() === name.toLowerCase()) {
                isRestrictedName = true;
                break;
            }
        }
        if (isRestrictedName) {
            setAddFolderModalShow(true);
        } else if (name.length > 188) {
            setAddFolderModalShow(true);
        } else {
            const addResp = await SearchManagementService.addFolder(defaultTitleId ? defaultTitleId : parentFolderId, name, history); // parentFolderId
            if (addResp.response_status == 0) {
                // if (getResponse && getResponse.response_content && getResponse.response_content.success.length > 0) {
                getFolderResultData();
                getDefaultSearchResult('folder', parentFolderId);
                //e.target.value = '';
                setShowNewFolder(false);
                setAddFolderText(true);
                utilsService.showToast(TOAST_TYPE.SUCCESS, 'Folder Added Successfully', toastRef)
                // }
            } else {
                // getDefaultSearchResult('folder', defaultTitleId);
                utilsService.showToast(TOAST_TYPE.ERROR, addResp.response_content.message, toastRef)
            }
        }
    }

    const closeNewFolderModal = () => {
        setEmptyNameError(false);
        setShowNewFolderModal(false);
    }
    const closeExportTableModal = () => {
        setExportModal(false);
    }

    async function getFolderResultData() {
        const folderData = await SearchManagementService.getProjectFolders(history);

        if (folderData && folderData.response_content) {
            let parentFolderId = folderData.response_content.id;
            const getResult = await SearchManagementService.getProjectFolderData(parentFolderId, history);
            if (getResult && getResult.response_content) {
                if (getResult.response_content.items && getResult.response_content.items.length > 0) {
                    let res = getResult.response_content.items[0];
                    setParentFolderId(res.id);
                    if (!defaultTitleId) { // Default to the root folder
                        setDefaultTitleId(parentFolderId);
                        res['isOpen'] = true;
                        setInfoFolderIds([res.id]);
                        setRootFolderId(res.id);
                    } else if (defaultTitleId === res.id) {
                        res['isOpen'] = true;
                        setInfoFolderIds([res.id]);
                    }
                    const ids = [];
                    JSON.stringify(res, (key, value) => {
                        if (key === 'id') ids.push(value);
                        return value;
                    });
                    // setFolderIds(["4086079","4087563","4087579"]);
                    setFolderIds(ids);
                    // Expand the existing folders
                    setExpandedFolderIds(ids);

                    // setInfoFolderIds([res.id]);
                    // Setting Level for Disable Add Folder Button
                    res.children.forEach(child1 => {
                        if (child1.child_status == "yes") {
                            child1.level = 1;
                            child1.children.forEach(child2 => {
                                if (child2.child_status == "yes") {
                                    child2.level = 2;
                                    child2.children.forEach(child3 => {
                                        if (child3.child_status == "yes") {
                                            child3.level = 3;
                                            child3.children.forEach(child4 => {
                                                child4.level = 4;
                                            });
                                        } else {
                                            child3.level = 3;
                                        }
                                    });
                                } else {
                                    child2.level = 2;
                                }
                            });
                        } else {
                            child1.level = 1;
                        }

                        // Set the last selected folder id
                        if (child1.id === defaultTitleId) {
                            res['isOpen'] = true;
                            child1['isOpen'] = true;
                        } else {
                            child1.children.forEach(child2 => {
                                if (child2.id === defaultTitleId) {
                                    res['isOpen'] = true;
                                    child1['isOpen'] = true;
                                    child2['isOpen'] = true;
                                } else {
                                    child2.children.forEach(child3 => {
                                        if (child3.id === defaultTitleId) {
                                            res['isOpen'] = true;
                                            child1['isOpen'] = true;
                                            child2['isOpen'] = true;
                                            child3['isOpen'] = true;
                                        } else {
                                            child3.children.forEach(child4 => {
                                                if (child4.id === defaultTitleId) {
                                                    res['isOpen'] = true;
                                                    child1['isOpen'] = true;
                                                    child2['isOpen'] = true;
                                                    child3['isOpen'] = true;
                                                    child4['isOpen'] = true;
                                                }
                                            });
                                        }
                                    });
                                }
                            });
                        }
                    });
                    // Getting All Array and map to find parent Object
                    mapIt(res);
                    setFolderDetail(res);
                }
            }
        }
    }
    const [folderResultCount, setFolderResultCount] = useState();
    const [searchResultData, setSearchResultData] = useState([]);
    const [clicked, setClicked] = useState(false);

    async function getDefaultSearchResult(type, id, start, stop, sortParam) {
        let tempArr = [];
        let pageStart, pageStop;
        if (start && stop) {
            pageStart = start;
            pageStop = stop;
        } else {
            pageStart = 1;
            pageStop = pageCount;
        }
        // setSearchResultData([]);
        if (type === "defaultText") {
            let recentParentId = parentFolderId;
            let folderData;
            if (!recentParentId) {
                folderData = await SearchManagementService.getProjectFolders(history);
                if (folderData && folderData.response_content) {
                    recentParentId = folderData.response_content.id;
                    setParentFolderId(recentParentId);
                }
            }

            const result = await SearchManagementService.getFolderData(id, history, pageStart, pageStop, sortParam);
            if (result && result.response_content) {
                setFolderResultCount(result.response_content.totalcount);
                if (result.response_content.results && result.response_content.results.length > 0) {
                    // tempArr = await UtilsService.mostRecentResCalculation(result, 'searchfolder');
                    // tempArr = await getSearchDataArr(result, 'searchfolder');
                }
            }
        }
        setSearchResultData(tempArr);
    }

    const selectedFolder = (event) => {
        if (event.selectable) {
            setMoveFolderId(event.id);
            setModalSelectedFolder(event.id); //  Also update modal selection
        }
        else {
            setMoveFolderId('');
            setModalSelectedFolder(null); //  Clear modal selection
        }

    }

    const toastRef = useRef(null);

    function greetUser() {
        const data = [];
        const dataValues = searchPersonalData && data.push(searchPersonalData.selectedRows[0]);
        if (searchPersonalData.selectedCount >= 1 && data && data.length > 0) {
            utilsService.showToast(TOAST_TYPE.SUCCESS, "Successfully Deleted", toastRef)
        }
        else {
            utilsService.showToast(TOAST_TYPE.ERROR, "Select Any One Item", toastRef)
        }
    }

    const closeMoveFolderModal = () => {
        setMoveFolderModalShow(false);
        setMoveFolderId('');
        setShowMergeModal(false);
    }
    const [mergeName, setMergeName] = useState('');
    const [mergeDescription, setMergeDescription] = useState('');
    const [mergeNameError, setMergeNameError] = useState('');
    const [mergeDescriptionError, setMergeDescriptionError] = useState('');
    const [saveIdDetails, setSaveIdDetails] = useState([]);

    async function getSelection() {
        setCheckMerge(false);
        var getIds = selectData.selectedRows.map(function (a) { return a.id; }).join(',');
        setSaveIdDetails(getIds);
        var moveableTo = await SearchManagementService.getMoveSelection(getIds, history);
        setMoveSelection(moveableTo.response_content.selection);
        setMoveInfoFolderIds([rootFolderId]);
        setConfirmFolderContent(true);
        openMoveFolderModal();
    }


    async function MergeDatabases() {
        setCheckMerge(true);

        var getIds = selectData.selectedRows.map(function (a) { return a.id; }).join(',');
        var moveable = await SearchManagementService.getMoveSelection(getIds, history);
        setMoveSelection(moveable.response_content.selection);
        setMoveInfoFolderIds([rootFolderId]);
        setConfirmFolderContent(true);
        openMoveFolderModal();
        // ⚠️ Ensure defaultTitleId is set before adding folder
        // if (!defaultTitleId && parentFolderId) {
        //     setDefaultTitleId(parentFolderId);
        // }
        const folderId = moveFolderId || parentFolderId || rootFolderId;
        console.log('parentFolderID', parentFolderId);
        const getResponse = await BrowseDatabaseServices.mergeBrowseDatabase(mergeName, mergeDescription, getIds, folderId, history);
        console.log("Final merge URL:", getResponse);
        //  Then call the folder add
        // addFolderName(mergeName);
        console.log('parentFolderID', parentFolderId);
        if (getResponse.response_status === 0) {
            addFolderName(mergeName);
        } else {
            utilsService.showToast(TOAST_TYPE.ERROR, getResponse.response_content.message, toastRef);
        }
    }


    async function moveToFolder() {
        setCheckMerge(false);
        setMoveFolderModalShow(false);
        var getIds = selectData.selectedRows.map(function (a) { return a.id; }).join(',');
        const getResponse = await SearchManagementService.moveToFolder(moveFolderId, getIds, history);
        if (getResponse.response_status == 0) {
            setClearCheckedRow(!clearCheckedRow);
            
            //  Clear the cache and refresh current view
            allResultSet = [];
            lastFetchedFolderId = null;
            await getBrowseDataBase(currentSortColumn, 1, PAGE_SIZE, false);
            setCurrentPage(1);
            
            if (defaultTitle === 'Recent Search Results') {
                getDefaultSearchResult('defaultText', '');
            } else {
                getDefaultSearchResult('folder', defaultTitleId);
            }
            getFolderResultData();
            utilsService.showToast(TOAST_TYPE.SUCCESS, 'Folder Moved Successfully', toastRef)
        } else {
            utilsService.showToast(TOAST_TYPE.ERROR, getResponse.response_content.message, toastRef)
        }

        handleClearSelection();
    }

    function openMoveFolderModal() {  
    //  Always use DlFolders from Reference Databases root
    if (allReferenceDLFolders && allReferenceDLFolders.length > 0) {
        const textLabels = allReferenceDLFolders.map(folder => ({
            id: folder.id,
            text_label: folder.text_label
        }));
        setModalChildren(textLabels);
    } else {
        console.warn('allReferenceDLFolders is EMPTY in openMoveFolderModal!');
    }
    setModalSelectedFolder(null);
    setMoveFolderModalShow(true);
    setShowMergeModal(true);
}

    const handleModalFolderClick = (event) => {
        setModalExpandedIds((prev) => {
            if (event.isOpen) {
                return Array.from(new Set([...prev, event.id]));
            } else {
                return prev.filter(id => id !== event.id);
            }
        });
        setMoveInfoFolderIds((prev) => {
            if (event.isOpen) {
                if (prev.includes(event.id)) {
                    return prev;
                }
                return [...prev, event.id];
            }
            return prev.filter(id => id !== event.id);
        });
    };
    const handleMoveFolderClick = (event) => {
        if (event['isOpen']) {
            moveInfoFolderIds.push(event.id);
        } else if (moveInfoFolderIds.includes(event.id)) {
            moveInfoFolderIds.splice(moveInfoFolderIds.indexOf(event.id), 1);
        }
        setMoveInfoFolderIds(moveInfoFolderIds);
    }
    const selectableRowsComponentProps = {
        type: 'checkbox',
        style: {
            color: toggle ? 'grey' : 'rgb(174, 169, 169)',  // white when toggle is true, black when false
        },
    };

    const [showDropdown, setShowDropdown] = useState(false);
    function ExportFunction() {
        setExportModal(true);
        // history.push('/home');
    }
    // async function exportToHTML() {
    //     setExportHtmlModal(true);

    // };
    function handleExportSelection(type) {
        setShowDropdown(false);
        setExportModal(false);

        if (type === "HTML") {
            exportHTMLNow(); // 🚀 open HTML export immediately
        } else if (type === "XLS") {
            exportToXLS(); // existing XLS export
        }
    }
    const exportToXLS = () => {
        // Pick only the required fields
        const filteredData = searchPersonalData.map(item => ({
            GQResourceID: item.id,
            Name: item.text_label_raw ?? item.title,
            Description: item.description,
            Status: item.Status,
            "Update Time": item.update_time,
            "Create Time": item.create_time,
            "Absolute Path": item.absolute_path,
        }));

        const worksheet = XLSX.utils.json_to_sheet(filteredData);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Data');

        const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
        const blob = new Blob([excelBuffer], { type: 'application/octet-stream' });
        saveAs(blob, 'export.xlsx');
    };

    const handleReferenceDatabaseClick = () => {
        setExpanded(!expanded);
        // Always open folderId = 4 when clicking "Reference Databases"
        setCurrentFolderId(4);
        setCurrentPage(1);  // reset to page 1

        // Show all folders as children under "Reference Databases"
        if (!expanded && referenceChildren.length === 0) {
            setReferenceChildren(allFolders); // allFolders already contains all folders from API
        }
    };
    const handleModalChildClick = ()=>{
        setExpandedChild(!expandedChild);
        //         // Always open folderId = 4 when clicking "Reference Databases"
        // setCurrentFolderId(4);
        // setCurrentPage(1);  // reset to page 1
        if(!expandedChild &&modalChildren.length === 0){
            setModalChildren(allFolderTextLabel);
        }
        // window.location.reload();
    }

    const openChildFolder = (folderId) => {
        console.log("openChildFolder called with id:", folderId);
        setCurrentFolderId(folderId);  // triggers useEffect -> getBrowseDataBase
        setCurrentPage(1);             // reset to page 1
    };

    // update child click handler
    const handleChildClick = (child) => {
        setMoveFolderId1(child.id);    // highlight clicked child
        openChildFolder(child.id);     // reuse existing logic
    };

    const handleMoveChildClick = (childId) => {
        setMoveFolderId1(childId);   // highlight only
        // ❌ don't call openChildFolder
    };

const handleMoveResult = async () => {
    const targetFolderId = modalSelectedFolder; //  Use modal selection only
    if (!targetFolderId) return;

    try {
        const getIds = selectData.selectedRows.map(a => a.id).join(',');
        const getResponse = await SearchManagementService.moveToFolder(targetFolderId, getIds, history);

        if (getResponse.response_status === 0) {
            utilsService.showToast(TOAST_TYPE.SUCCESS, 'Folder Moved Successfully', toastRef);
            
            // Clear cache and refresh
            allResultSet = [];
            lastFetchedFolderId = null;              
            await getBrowseDataBase(currentSortColumn, 1, PAGE_SIZE, false);
            setCurrentPage(1);
            getFolderResultData();
            handleClearSelection();
        } else {
            utilsService.showToast(TOAST_TYPE.ERROR, getResponse.response_content.message, toastRef);
        }

        setMoveFolderModalShow(false);
        setModalSelectedFolder(null); //  Clear modal selection after move
        setMoveFolderId('');
    } catch (err) {
        console.error("Error moving result:", err);
    }
};
    const closeModal = () => {
        setModalShow(false);
        setTermsDisable(false);
        setConfirmContent(true);
        // setShowMergeModal(false);
    };
    const toggleChildExpanded = (childId, isMoveModal = false) => {
        setChildExpanded((prev) => ({
            ...prev,
            [childId]: !prev[childId],
        }));

        if (!isMoveModal) {
            // Only in main explorer: load databases
            openChildFolder(childId);
        }
    };
    const openMoveModal = () => {
        // filter only dlfolders from allFolders
        const onlyDLfolders = allFolders.filter(f => f.type === "dlfolder"); 
        setModalChildren(onlyDLfolders);

        moveFolderModalShow(true); // or however you toggle modal visibility
    };

    return (
        <div >
            <Row className={classes.columnPad} >
                <Col md="2.5" sm="2.5" xs="2.5">
                    <Col md="12" className="appTextColor">
                        <ListGroup className="projectList" style={{ maxHeight: "44%", overflow: "auto" }}>
                            {/* Parent item */}
{/* LEFT PANEL - Reference Databases */}
<ListGroup.Item
    key="ref-databases-left"
    className={toggle ? classes.projectListItem : classes.projectListItemDark}
    style={{ cursor: 'pointer', display: 'flex', alignItems: 'center' }}
>
    {/* Left Panel Arrow */}
    <span
        onClick={(e) => {
            e.stopPropagation();
            setLeftPanelExpanded(!leftPanelExpanded); //  Only affects left panel
            if (!leftPanelExpanded && leftPanelChildren.length === 0) {
                setLeftPanelChildren(allReferenceDLFolders); //  Use allReferenceDLFolders, not allFolders
            }
        }}
        style={{ marginRight: '2px', cursor: 'pointer', fontSize: '12px' }}
    >
        <img
            src={leftPanelExpanded ? sortdown : sortright} //  Uses left panel state
            alt="toggle"
            style={{
                width: "15px",
                height: "15px",
                objectFit: "contain",
                display: "inline-block",
                filter: "brightness(0.7) invert(0)",
                verticalAlign:'middle'
            }}
        />
    </span>

    {/* Left Panel Folder */}
    <div
        onClick={() => {
            setLeftPanelExpanded(!leftPanelExpanded);
            setCurrentFolderId(4); 
            setCurrentPage(1);
            setLeftPanelSelectedFolder(null); 
            if (!leftPanelExpanded && leftPanelChildren.length === 0) {
                setLeftPanelChildren(allReferenceDLFolders); 
            }
        }}
        style={{ display: 'flex', alignItems: 'center' }}
    >
        <img src={folderIcon} alt="folder" style={{ width: '16px', height: '16px', marginRight: '4px' }} />
        <span>Reference Databases</span>
    </div>
</ListGroup.Item>

{/* Left Panel Children */}
{leftPanelExpanded && leftPanelChildren.map((child) => (
    <ListGroup.Item
        key={`left-${child.id}`}
        style={{
            paddingLeft: '20px',
            cursor: 'pointer',
            padding: '8px',
            border: 'none',
            marginLeft: '0px',
            backgroundColor: leftPanelSelectedFolder === child.id ? (toggle ? '#e3e5ea' : '#337ab7') : 'transparent', 
            display: 'flex',
            alignItems: 'center'
        }}
        onClick={() => {
            setShowLoader(true); 
            setLeftPanelSelectedFolder(child.id); 
            setCurrentFolderId(child.id);         
            setCurrentPage(1);
        }}
    >
        <img
            src={sortright}
            alt="arrow"
            style={{
                width: '15px',
                height: '15px',
                marginRight: '4px',
                filter: 'brightness(0.7) invert(0)',
                verticalAlign: 'middle'
            }}
        />
        <img src={folderIcon} alt="folder" style={{ width: '16px', height: '16px', marginRight: '6px' }} />
        {child.text_label}
    </ListGroup.Item>
))}
                        </ListGroup>
                    </Col>
                </Col>
                <Col>
                    {/* <div className="data-table-wrapper"  style={{ backgroundColor: searchPersonalData.length === 0 ? '#FFFFFF' : '#292929' }}></div> */}
                    <DataTable
                        className={`search-table ${classes.tableResizable}`}
                        columns={columns}
                        data={searchPersonalData}
                        defaultSortField="title"
                        onSelectedRowsChange={updateVal}
                        customStyles={toggle ? customStyles : customStylesDark}
                        noHeader={true}
                        clearSelectedRows={toggleCleared}
                        noDataComponent='No items were found.'
                        selectableRows
                        selectableRowsComponent={Checkbox}
                        selectableRowsComponentProps={selectableRowsComponentProps}
                        onSort={(column, sortDirection) => {
                            sortTable(column, sortDirection);
                        }}
                        fixedHeader={false}
                        dense={false}
                    />
                </Col>
            </Row>

            {/* <Col>
                <span className="text-muted small">
                {(currentPage - 1) * pageCount + 1}–{Math.min(currentPage * pageCount, totalCount)} of {totalCount}
                </span>
            </Col> */}

            {/* Arrows only (right) */}

            <Col className={'d-flex justify-content-center' + (searchPersonalData.length > 0 ? ' d-block' : ' d-none')} md="12">
                <CustomPagination className={"float-right mt-2"} count={totalCount ? totalCount : 0} changePage={changePage} recordPerPage={pageCount} showFirstButton showLastButton defaultPage={1} page={currentPage} />
            </Col>


            <Row className="float-right" style={{ paddingTop: '20px' }}>
                {/* <Col  className={classes.columnPadding}>
    <Button variant="contained" className={classes.buttonStyleCancel} onClick={homePage}>Cancel</Button>
     &nbsp;&nbsp;&nbsp;
    <Button color="primary" className='accountinfo' variant="contained" onClick={()=>deleteTemplate()} className="float-right loginSubmit text-capitalize" type="submit">Delete Selected Saved Search Forms</Button>   
  
      </Col> */}
                <div className={classes.footerDiv}>
                    {searchPersonalData && searchPersonalData.length != 0 &&
                        <Fragment>   
                            {thing.selectedCount >= 1 ?
                                <Button color={(!checkValue ? 'default' : 'secondary')} style={{ margin: '4px 10px 4px 0 !important' }} className={"text-capitalize float-left" + ' ' + (!checkValue ? classes.buttonStyle : classes.disabledButtonStyle) + ' mr-2'} disableRipple={true} onClick={() => deleteTemplate()}   variant="contained">Delete Selected Database</Button>
                                : <Button color={(!checkValue ? 'default' : 'secondary')} style={{ margin: '4px 10px 4px 0 !important' }} className={"text-capitalize float-left" + ' ' + (!checkValue ? classes.buttonStyle : classes.disabledButtonStyle) + ' mr-2'} variant="contained"  >Delete Selected Database</Button>

                            }
                            &nbsp;&nbsp;&nbsp;&nbsp;
                            {thing.selectedCount >= 1 ?
                                <Button className={"text-capitalize float-left" + ' ' + (!checkValue ? classes.buttonStyle : classes.disabledButtonStyle) + ' mr-2'} color={(!checkValue ? 'default' : 'secondary')} style={{ margin: '4px 10px 4px 0 !important' }} disableRipple={true} onClick={getSelection} type="submit" variant="contained">Move to Folder</Button>
                                : <Button className={"text-capitalize float-left" + ' ' + (!checkValue ? classes.buttonStyle : classes.disabledButtonStyle) + ' mr-2'} color={(!checkValue ? 'default' : 'secondary')} style={{ margin: '4px 10px 4px 0 !important' }} variant="contained">Move to Folder</Button>
                            }
                            &nbsp;&nbsp;&nbsp;&nbsp;     
                            {/* <Button  style={{ margin: '4px 10px 4px 0 !important' }}  variant="contained" onClick={getSelection} className={"text-capitalize float-left" + ' ' + (disableDelete ? classes.buttonStyle : classes.disabledButtonStyle) + ((defaultTitle == 'Recent Search Results') ? ' d-none' : ' d-block') + ' mr-2'} type="submit">{t('moveToFolder')}</Button> */}

                            <Modal
                                show={moveFolderModalShow}
                                size="lg"
                                aria-labelledby="contained-modal-title-vcente"
                                centered
                                contentClassName={classes.modalClassConMTF}
                                className={classes.modalBoxContent}
                                enforceFocus={false}
                                restoreFocus={false}
                            >
                                <div className={classes.modalHeaderConMTF}>
                                    <a href="#" onClick={(e) => e.preventDefault()} className={classes.modaltext}>
                                        <CloseIcon onClick={closeMoveFolderModal} />
                                    </a>
                                </div>

                                <Modal.Body className={toggle ? classes.modal_body : classes.modal_bodyDark}>
                                    <div className={toggle ? classes.colorConMTF : classes.colorConMTFDark}>
                                        <div className={(confirmFolderContent ? 'd-block' : 'd-none')}>
                                            <div className="mb-3">
                                                <b>Move To Folder</b>


                                {!checkMerge && (
                                                    <>
                                                        <ListGroup.Item
                                                            key="ref-databases-modal"
                                                            className={toggle ? classes.projectListItem : classes.projectListItemDark}
                                                            style={{ cursor: 'pointer', display: 'flex', alignItems: 'center', backgroundColor: '#d9dbdc' }}
                                                        >
                                                            {/* Modal Arrow */}
                                                            <span
                                                                onClick={(e) => {
                                                                    e.stopPropagation();
                                                                    console.log('Arrow clicked - BEFORE toggle:', { 
                                                                        modalExpanded, 
                                                                        modalChildrenLength: modalChildren.length,
                                                                        allReferenceDLFoldersLength: allReferenceDLFolders?.length 
                                                                    });
                                                                    
                                                                    
                                                                    if (!modalExpanded) {
                                                                        console.log('Expanding - populating modalChildren from allReferenceDLFolders');
                                                                        
                                                                        if (allReferenceDLFolders && allReferenceDLFolders.length > 0) {
                                                                            const textLabels = allReferenceDLFolders.map(folder => ({
                                                                                id: folder.id,
                                                                                text_label: folder.text_label
                                                                            }));
                                                                            console.log('Setting modalChildren:', textLabels);
                                                                            setModalChildren(textLabels);
                                                                        } else {
                                                                            console.warn('allReferenceDLFolders is empty or undefined!');
                                                                        }
                                                                    } else {
                                                                        console.log('Collapsing - clearing modalChildren');
                                                                    }
                                                                    
                                                                    setModalExpanded(!modalExpanded); 
                                                                }}
                                                                style={{ marginRight: '4px', cursor: 'pointer', fontSize: '12px' }}
                                                            >
                                                                <img
                                                                    src={modalExpanded ? sortdown : sortright} 
                                                                    alt="toggle"
                                                                    style={{
                                                                        width: "15px",
                                                                        height: "15px",
                                                                        objectFit: "contain",
                                                                        display: "inline-block",
                                                                        filter: "brightness(0.7) invert(0)",
                                                                        verticalAlign:'middle',
                                                                    }}
                                                                />
                                                            </span>
                                                            {/* Modal Folder */}
                                                            <div
                                                                onClick={(e) => {
                                                                    e.stopPropagation();
                                                                    setModalSelectedFolder(4); //  Select root for move operation only
                                                                }}
                                                                style={{ display: 'flex', alignItems: 'center' }}
                                                            >
                                                                <img src={folderIcon} alt="folder" style={{ width: "20px", height: "20px", marginRight: "4px" }} />
                                                                <span>Reference Databases</span>
                                                            </div>
                                                        </ListGroup.Item>
                                                        {/* Modal Children */}
                                                        {console.log('Rendering modal children:', { modalExpanded, modalChildrenCount: modalChildren?.length, modalChildren })}
                                                        {modalExpanded && modalChildren && modalChildren.length > 0 ? (
                                                            modalChildren.map((child) => (
                                                                <ListGroup.Item
                                                                    key={`modal-${child.id}`}
                                                                    style={{
                                                                        paddingLeft: '24px',
                                                                        cursor: 'pointer',
                                                                        padding: '0',
                                                                        border: 'none',
                                                                        marginLeft: '17px',
                                                                        backgroundColor: modalSelectedFolder === child.id ? '#e3e5ea' : 'transparent', 
                                                                    }}
                                                                    onClick={() => {
                                                                        console.log('Folder selected in modal:', child);
                                                                        setModalSelectedFolder(child.id); // Only for move operation, doesn't affect main table
                                                                    }}
                                                                >
                                                                    <img src={folderIcon} alt="folder" style={{ width: '16px', height: '16px', marginRight: '6px', backgroundColor: '#d9dbdc' }} />
                                                                    {child.text_label}
                                                                </ListGroup.Item>
                                                            ))
                                                        ) : modalExpanded ? (
                                                            <div style={{ paddingLeft: '24px', fontStyle: 'italic', color: '#999' }}>
                                                                No folders available
                                                            </div>
                                                        ) : null}
                                                    </>
                                                )}
                                                {/* {showReferenceChildren && (
                                                    <div style={{ marginLeft: '20px' }}>
                                                        {referenceChildren.length > 0 ? (
                                                            referenceChildren.map(child => (
                                                                <ListGroup.Item
                                                                    key={child.id}
                                                                    className={toggle ? classes.projectListItem : classes.projectListItemDark}
                                                                    style={{ cursor: 'pointer' }}
                                                                    onClick={() => {
                                                                        console.log(`Loading ${child.name}`);
                                                                        getBrowseDataBase(child.id); // load data for that child
                                                                    }}
                                                                >
                                                                    📄 {child.name}
                                                                </ListGroup.Item>
                                                            ))
                                                        ) : (
                                                            <p style={{ marginLeft: '10px', fontStyle: 'italic' }}>No databases found</p>
                                                        )}
                                                    </div>
                                                )} */}
                                            </div>

                                            {checkMerge && (
                                                <div className="mb-4">
                                                    <label className="d-block mb-2"><b>Name:</b></label>
                                                    <input
                                                        type="text"
                                                        className={`form-control mb-1 ${mergeNameError ? 'isInvalid' : ''}`}
                                                        placeholder="Enter merge name"
                                                        value={mergeName}
                                                        onChange={(e) => {
                                                            setMergeName(e.target.value);
                                                            if (mergeNameError) setMergeNameError(''); // Clear error on change
                                                        }}
                                                    />
                                                    {mergeNameError && <div className="text-danger mb-2">{mergeNameError}</div>}

                                                    <label className="d-block mb-2 mt-3"><b>Description:</b></label>
                                                    <textarea
                                                        className={`form-control ${mergeDescriptionError ? 'isInvalid' : ''}`}
                                                        rows={3}
                                                        placeholder="Enter description"
                                                        value={mergeDescription}
                                                        onChange={(e) => {
                                                            setMergeDescription(e.target.value);
                                                            if (mergeDescriptionError) setMergeDescriptionError('');
                                                        }}
                                                    />
                                                    {mergeDescriptionError && <div className="text-danger mt-1">{mergeDescriptionError}</div>}
                                                </div>
                                            )}

                                            {checkMerge &&
                                                <div className='scrollMoveItem'>
                                                    <p className="mb-3">{('Select Folder To Move')}</p>
                                                    <div className="mb-3 h-100">{/* */}
                                                        <FolderTreeMenu
                                                            key="modal-tree"
                                                            items={moveSelection}
                                                            infoFolderIds={moveInfoFolderIds}
                                                            expandedIds={modalExpandedIds}
                                                            moveFolderId={moveFolderId}
                                                            moveFolderCallback={(event) => {
                                                                // Prevent scroll jump only in modal
                                                                if (typeof window !== 'undefined') {
                                                                    // Block scroll only for modal context
                                                                    if (window.scrollY !== 0) {
                                                                        // Do not scroll
                                                                    }
                                                                }
                                                                selectedFolder(event);
                                                            }}
                                                            type="moveFolder"
                                                            parentCallback={handleModalFolderClick}
                                                        />
                                                    </div>
                                                </div>

                                            }

                                            <div className={classes.footerDivMTF + " float-right"}>
                                                <Button onClick={closeMoveFolderModal} className={classes.loginSubmitCancel}  >{('cancel')}</Button>
                                                {checkMerge ? (
                                                    <Button
                                                        onClick={async () => {
                                                            let valid = true;

                                                            if (mergeName.trim() === '') {
                                                                setMergeNameError('Name is required.');
                                                                valid = false;
                                                            }
                                                            if (mergeDescription.trim() === '') {
                                                                setMergeDescriptionError('Description is required.');
                                                                valid = false;
                                                            }

                                                            if (!valid) return;

                                                            const getIds = selectData.selectedRows.map(a => a.id).join(',');
                                                            const folderId = moveFolderId || parentFolderId || rootFolderId;
                                                            // Step 1: Merge the databases
                                                            const getResponse = await BrowseDatabaseServices.mergeBrowseDatabase(
                                                                mergeName, mergeDescription, getIds, folderId, history
                                                            );
                                                            console.log("Final merge URL:2 = ", getResponse);

                                                            if (getResponse.response_status === 0) {
                                                                // Step 2: Create the folder with the merge name
                                                                await addFolderName(mergeName);

                                                                // Step 3: Open the folder or show modal
                                                                moveToFolder();
                                                                // window.location.reload();
                                                            } else {
                                                                utilsService.showToast(TOAST_TYPE.ERROR, getResponse.response_content.message, toastRef);
                                                                console.error("Merge error:", getResponse.response_content.message);
                                                            }
                                                        }}
                                                        color={modalSelectedFolder === '' ? 'default' : 'primary'}
                                                        disabled={modalSelectedFolder === ''}
                                                        className={`text-capitalize mr-2 ${modalSelectedFolder === '' ? 'cancelButtonDisable' : 'accountInfo'}`}
                                                        variant="contained"
                                                    >
                                                        Merge Result
                                                    </Button>
                                                ) : (
                                                    <Button
                                                        onClick={handleMoveResult}
                                                        color={modalSelectedFolder === '' ? 'default' : 'primary'}
                                                        disabled={modalSelectedFolder === ''}
                                                        className={`text-capitalize mr-2 ${modalSelectedFolder === '' ? 'cancelButtonDisable' : 'accountInfo'}`}
                                                        variant="contained"
                                                    >
                                                        Move Result
                                                    </Button>
                                                )}

                                            </div>
                                        </div>
                                    </div>
                                </Modal.Body>
                            </Modal>

                            <Modal
                                show={showNewFolderModal}
                                size="lg"
                                aria-labelledby="contained-modal-title-vcente"
                                centered
                                contentClassName={toggle ? classes.modalClassConDSI : classes.modalClassConDSIDark}
                                className={classes.modalBoxContent}
                                animation={false}
                            >
                                <Link href="#" onClick={(e) => e.preventDefault()} className={classes.modaltext}>
                                    <CloseIcon onClick={closeNewFolderModal} />
                                </Link>
                                <div className={classes.modal_body_selected + " appTextColor"}>
                                    <div className={toggle ? classes.colorConDSI : classes.colorConDSIDark}>
                                        <div className="d-block">
                                            <p className="mb-3"><b>{('Create Sub Folder')}</b></p>
                                            <div className="mb-5 h-100">
                                                <TextInput
                                                    id="addNewFolder"
                                                    name="addFolder"
                                                    label={('newFolder')}
                                                    value={newFolderName}
                                                    variant="outlined"
                                                    className={"float-left"}
                                                    onKeyDown={getFolderName}
                                                    inputProps={{
                                                        maxLength: 180
                                                    }}
                                                    inputRef={folderNameRef}
                                                    fullWidth={true}
                                                    autoComplete="off"
                                                    autoFocus={true}
                                                />
                                            </div>
                                            {emptyNameError &&
                                                <span style={{ color: 'red' }}>{('Folder Name shouldnot be empty')}</span>}
                                            <br />
                                            <div className={classes.footerDiv + " float-right"}>
                                                <Button onClick={closeNewFolderModal} className={classes.loginSubmitCancel} >{('cancel')}</Button>
                                                <Button color="primary" className="text-capitalize mr-2 accountInfo" onClick={() => addFolderName(folderNameRef.current.value)} variant="contained">{('OK')}</Button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </Modal>
                            &nbsp;&nbsp;&nbsp;&nbsp;
                            {/* {thing.selectedCount >= 1 ?
                                <Button color={(!checkValue ? 'default' : 'secondary')} style={{ margin: '4px 10px 4px 0 !important' }} className={"text-capitalize float-left" + ' ' + (!checkValue ? classes.buttonStyle : classes.disabledButtonStyle) + ' mr-2'} disableRipple={true} onClick={BrowseDatabase} variant="contained"  >Browse</Button>
                                : <Button color={(!checkValue ? 'default' : 'secondary')} style={{ margin: '4px 10px 4px 0 !important' }} className={"text-capitalize float-left" + ' ' + (!checkValue ? classes.buttonStyle : classes.disabledButtonStyle) + ' mr-2'} disableRipple={true} onClick={BrowseDatabase} variant="contained"  >Browse</Button>

                            } */}

                            <Button
                                disabled={!canMergeDatabases}
                                color={canMergeDatabases ? "secondary" : "default"}
                                style={{ margin: '4px 10px 4px 0 !important' }}
                                className={
                                    "text-capitalize float-left mr-2 " +
                                    (canMergeDatabases ? classes.disabledButtonStyle : classes.buttonStyle)
                                }
                                disableRipple={true}
                                onClick={() => {
                                    if (canMergeDatabases) {
                                        setCheckMerge(true);
                                        const getIds = selectData.selectedRows.map(a => a.id).join(',');
                                        SearchManagementService.getMoveSelection(getIds, history).then(moveable => {
                                            setMoveSelection(moveable.response_content.selection);
                                            setMoveInfoFolderIds([rootFolderId]);
                                            setConfirmFolderContent(true);
                                            openMoveFolderModal();
                                        });
                                    }
                                }}
                                variant="contained"
                            >
                                Merge Databases
                            </Button>

                            {showLoader &&
                                <div className={classes.loader}>
                                    <div className={classes.loaderPosition}>
                                        <div className="spinner-container">
                                            <div className="spinner-socket">
                                                <div className="spinner-hex spinner-tile-1">
                                                    <div className="spinner-brick rotate-0"></div>
                                                    <div className="spinner-brick rotate-1"></div>
                                                    <div className="spinner-brick rotate-2"></div>
                                                </div>
                                                <div className="spinner-hex spinner-tile-2">
                                                    <div className="spinner-brick rotate-0"></div>
                                                    <div className="spinner-brick rotate-1"></div>
                                                    <div className="spinner-brick rotate-2"></div>
                                                </div>
                                                <div className="spinner-hex spinner-tile-3 spinner-row-2">
                                                    <div className="spinner-brick rotate-0"></div>
                                                    <div className="spinner-brick rotate-1"></div>
                                                    <div className="spinner-brick rotate-2"></div>
                                                </div>
                                                <div className="spinner-hex spinner-tile-4 spinner-row-2">
                                                    <div className="spinner-brick rotate-0"></div>
                                                    <div className="spinner-brick rotate-1"></div>
                                                    <div className="spinner-brick rotate-2"></div>
                                                </div>
                                                <div className="spinner-hex spinner-tile-5 spinner-row-2">
                                                    <div className="spinner-brick rotate-0"></div>
                                                    <div className="spinner-brick rotate-1"></div>
                                                    <div className="spinner-brick rotate-2"></div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            }
                            {/* {checkValue && thing.selectedCount >= 2 ?
                                <Button color={(!checkValue ? 'default' : 'secondary')} style={{ margin: '4px 10px 4px 0 !important' }} className={"text-capitalize float-left" + ' ' + (!checkValue ? classes.buttonStyle : classes.disabledButtonStyle) + ' mr-2'} disableRipple={true} onClick={() => MergeDatabases()} variant="contained">Merge</Button>
                                : <Button color={(!checkValue ? 'default' : 'secondary')} style={{ margin: '4px 10px 4px 0 !important' }} className={"text-capitalize float-left" + ' ' + (!checkValue ? classes.buttonStyle : classes.disabledButtonStyle) + ' mr-2'} disableRipple={true} onClick={() => MergeDatabases()} variant="contained">Merge</Button>

                            } */}
                            &nbsp;&nbsp;&nbsp;&nbsp;
                            <Button style={{ margin: '4px 10px 4px 0 !important', marginTop: '4px', backgroundColor: '#db862c', color: 'white' }} disableRipple={true} className={"text-capitalize float-left" + ' '} onClick={() => ExportFunction()} variant="contained">Export Table</Button>
                            <Modal
                                show={exportModal}
                                size="md"
                                aria-labelledby="contained-modal-title-vcente"
                                centered
                                contentClassName={toggle ? classes.modalClassConDSI : classes.modalClassConDSIDark}
                                className={classes.modalBoxContent}
                                animation={false}
                            >
                                <Link href="#" onClick={(e) => e.preventDefault()} className={classes.modaltext}>
                                    <CloseIcon onClick={closeExportTableModal} />
                                </Link>
                                <div className={classes.modal_body_selected + " appTextColor"}>
                                    <div className={toggle ? classes.colorConDSI : classes.colorConDSIDark}>
                                        <div className="d-block">
                                            <div className="mb-5 h-100">
                                                <p style={{fontSize:'x-large'}}> <b>You are about to export all items.</b></p>

                                                <button 
                                                    onClick={() => setShowDropdown(!showDropdown)} 
                                                    style={{ 
                                                        padding: '8px 16px',
                                                        fontWeight: 'normal',
                                                        border: '1px solid #ccc',
                                                        backgroundColor: '#fff',
                                                        cursor: 'pointer',
                                                        borderRadius: '4px'
                                                    }}
                                                >
                                                <span style={{ fontWeight: 'normal' }}>Export</span> 
                                                <span style={{ fontWeight: 'normal', fontSize: '12px' }}> ▼</span>
                                                </button>
                                                {showDropdown && (
                                                    <div style={{
                                                        position: 'absolute',                               
                                                        border: '1px solid #ccc',
                                                        boxShadow: '0px 4px 8px rgba(0,0,0,0.1)',
                                                        zIndex: 10,
                                                        marginTop: '4px',
                                                        width: '50%'
                                                    }}>
                                                        <div 
                                                            onClick={() => { handleExportSelection('HTML'); setShowDropdown(false); }} 
                                                            onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { handleExportSelection('HTML'); setShowDropdown(false); } }}
                                                            role="button"
                                                            tabIndex={0}
                                                            style={{ padding: '8px', cursor: 'pointer' }}
                                                        >
                                                            HTML
                                                        </div>
                                                        <div 
                                                            onClick={() => { handleExportSelection('XLS'); setShowDropdown(false); }} 
                                                            onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { handleExportSelection('XLS'); setShowDropdown(false); } }}
                                                            role="button"
                                                            tabIndex={0}
                                                            style={{ padding: '8px', cursor: 'pointer' }}
                                                        >
                                                            XLS
                                                        </div>
                                                    </div>
                                                )}

                                            </div>
                                            <br />
                                            <div className={classes.footerDiv + " float-right"}>
                                                <Button onClick={closeExportTableModal} className={classes.loginSubmitCancel} >{('cancel')}</Button>
                                                {/* <Button color="primary" className="text-capitalize mr-2 accountInfo" onClick={() => addFolderName(folderNameRef.current.value)} variant="contained">{('OK')}</Button> */}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </Modal>
                            {/* <BrowseDBDeleteModal
                                show={modalShow}
                                onHide={() => cancelForms()}
                                tryAgain={() => deleteForm()}
                            // onMessage={errorMessage}
                            /> */}
                            <Modal
                                show={modalShow}
                                size="lg"
                                aria-labelledby="contained-modal-title-vcente"
                                centered
                                contentClassName={toggle ? classes.modalClassConDSI: classes.modalClassConDSIDark}
                                className={classes.modalBoxContent}
                
                            >
                                {/* <Modal.Header className={classes.modalHeader}>
                                    <Link href="#" onClick={(e) => e.preventDefault()} className={classes.modaltext}>
                                        <CloseIcon onClick={closeModal} />
                                    </Link>
                                </Modal.Header> */}
                                <Link href="#" onClick={(e) => e.preventDefault()} className={classes.modaltext}>
                                    <CloseIcon onClick={closeModal} />
                                </Link>
                                <div className={classes.modal_body_selected + " appTextColor"}>
                                    <div className={toggle ? classes.colorConDSI : classes.colorConDSIDark}>
                                        <div 
                                        className={(confirmContent ? 'd-block' : 'd-none')}
                                        >
                                            <p className="mb-3"><b>{('Deleted Selected Items')}</b></p>
                                            <p className="mb-3">{('This will permanently delete the results and folders you have selected')}.<b>{('This action can not be undone')}</b>.</p>
                                            <div className="mb-5 h-100">
                                                <Checkbox
                                                    color="primary"
                                                    className={"float-left p-0 " + classes.checkBox}
                                                    name="acceptTerms"
                                                    id="acceptTerms"
                                                    checked={termsDisable}
                                                    onClick={() => setTermsDisable(!termsDisable)}
                                                    style={toggle ? {color: 'black'}: {color: 'white'}}                                />
                                                <p className={"float-left ml-1"}>{('I have read and understood this message​.')}</p>
                                            </div>
                                            <div className={classes.footerDiv + " float-right"}>
                                                <Button onClick={closeModal} className={classes.loginSubmitCancel} >{('cancel')}</Button>
                
                                                <Button 
                                                onClick={() => deleteForm()} 
                                                color={(!termsDisable ? 'default' : 'secondary')} disabled={!termsDisable} className={"text-capitalize mr-2 " + ' ' + (!termsDisable ? 'cancelButtonDisable' : 'accountInfo')} variant="contained">{('Delete Selected Items')}</Button>
                                            </div>
                                        </div>
                                        <div 
                                        className={"text-center " + (delLoaderContent ? 'd-block' : 'd-none')}
                                        >
                                            <p className="mb-3">{('deletingItems')}</p>
                                            <p className="mb-3">{('takeTimeText')}</p>
                                        </div>
                                        <div 
                                        className={(errorContent ? 'd-block' : 'd-none')}
                                        >
                                            <p className="mb-3">{('errorDeletTitle')}</p>
                                            <p className="mb-3">{('contactText1')} <a href="GQ-Support@aptean.com" onClick={(e) => e.preventDefault()}>GQ-Support@aptean.com</a> {('contactText2')}</p>
                                            <div className={" float-right"}>
                                                <Button onClick={closeModal} className="text-capitalize float-right mr-2 primaryBtn" color="secondary" variant="contained">{('close')}</Button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </Modal>

                        </Fragment>

                    }
                </div>
            </Row>
        </div>
    );
}


export default BrowseDatabases;